<template>
  <el-container class="goal-list">
    <el-card>
      <div slot="header" class="clearfix">
        <h5 style="display: inline">Calendar</h5>
        <el-button style="float: right; margin: 0" type="secondary" size="mini" @click="debug_show_calendar = !debug_show_calendar">{{debug_show_calendar ? 'hide' : 'show'}}</el-button>
      </div>
      <div v-if="debug_show_calendar" >
        <full-calendar :events="optimizer_results_calendar" :config="calendar_config" :editable="calendar_config.editable" :selectable="calendar_config.selectable"></full-calendar>
        <br />
        <pre v-show="debug_show_calendar">{{optimizer_results_calendar}}</pre>
      </div>
    </el-card>
    <el-card style="margin-left: 0">
      <div slot="header" class="clearfix">
        <h5 style="display: inline">Optimier Results (Table)</h5>
        <el-button style="float: right; margin: 0" type="secondary" size="mini" @click="debug_show_table = !debug_show_table">{{debug_show_table ? 'hide' : 'show'}}</el-button>
      </div>
      <!--el-table v-if="debug_show_table" :data="mapped_optimizer_results" border style="width: 100%">
        <el-table-column prop="day" label="Day" sortable />
        <el-table-column prop="start" label="From" sortable />
        <el-table-column prop="end" label="To" sortable />
        <el-table-column prop="commitmentId" label="CommitmentId" sortable />
      </el-table> -->
    </el-card>
    <!-- <pre>{{ this.flattened_calendar_data_all }} </pre> -->
    <!--Commitment Ids
    <pre>{{ effort_list_all }}</pre>

    Timeslot Collections
    <pre> {{ timeslot_collection_list}}</pre>
-->

    <el-container class="goal-list">

    <el-aside width="500px">

        <el-card>
          <div slot="header" class="clearfix">
            <h2 style="display: inline">Zielkategorien</h2>
            <el-row v-for="timeslotCollection in timeslotCollectionsSelectOptions" :key="timeslotCollection.id">
              <el-col :span="24">
                {{ timeslotCollection.label }}
              </el-col>
              <el-row v-for="commitment in effort_list_all" :key="commitment.id" v-if="commitment.timeslotCollectionId === timeslotCollection.id">
                <el-col :span="1"> &nbsp;
                </el-col>
                <el-col :span="23">
                  <pre> {{ commitment }} </pre>
                </el-col>
              </el-row>
            </el-row>
          </div>

        </el-card>
      </el-aside>

      <el-container>
        <el-main style="padding: 0">
          <el-card style="margin-left: 0">

            <div slot="header" class="clearfix">
              <h4 style="display: inline">Optimizer</h4>
              <el-button-group style="float: right">
                <el-button type="primary" size="small" style="margin: 0" @click="runOptimize" :disabled="optimization_running">
                  <i v-show="optimization_running" class="fa fa-spinner fa-spin"></i>
                  Optimize
                </el-button>
                <el-button type="secondary" size="small" style="margin: 0" @click="onExportJSON">Export JSON</el-button>
              </el-button-group>
            </div>

            <div v-if="user_error" class="alert alert-danger" role="alert">
              <strong>Error!</strong> {{user_error}}
            </div>

            <div v-if="optimizer_result_data" class="alert alert-success" role="alert">
              <strong>Optimization done</strong>
              <pre style="background-color: unset; padding: 0">Optimizer Response Time: {{debug_optimizer_response_time}} ms
Effective Optimization Time: {{(optimizer_result_data && 'stats' in optimizer_result_data ) ? Math.round(optimizer_result_data['stats']['seconds'] * 1000) : 0}} ms</pre>
            </div>

            <el-form label-width="80px" size="mini" @submit.native.prevent>
              <el-form-item label="Planning horizon:">
                <el-input-number
                  v-model="planning_horizon"
                  size="small"
                  placeholder="14" />
              </el-form-item>
              <el-form-item label="Algorithm:">
                <el-radio-group v-model="optimizer_algorithm" style="padding-top: 5px">
                  <el-radio label="goalpilot_action_plan">goalpilot_action_plan</el-radio>
                  <br />
                  <el-radio label="goalpilot_action_plan_nfs">goalpilot_action_plan_nfs</el-radio>
                  <br />
                  <el-radio label="goalpilot_action_plan_v2">goalpilot_action_plan_v2</el-radio>
                  <br />
                  <el-radio label="goalpilot_action_plan_v3">goalpilot_action_plan_v3</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="Timezone:">
                <TimezonePicker v-model="user_timezone" />
              </el-form-item>
            </el-form>

            <a href="#" @click.prevent="
              debug_show_optimizer_settings =
              debug_show_optimizer_results_raw =
              debug_show_optimizer_results = false;
            ">hide all</a> |
            <a href="#" @click.prevent="
              debug_show_optimizer_settings =
              debug_show_optimizer_results_raw =
              debug_show_optimizer_results = true;
            ">show all</a>
            <br />
            <br />

            <h4>Optimizer Settings/Input:</h4>
            <a href="#" @click.prevent="debug_show_optimizer_settings = !debug_show_optimizer_settings">{{debug_show_optimizer_settings ? 'hide' : 'show'}}</a>
            <pre v-show="debug_show_optimizer_settings">{{optimizer_settings_text}}</pre>
            <pre v-show="!debug_show_optimizer_settings">{...}</pre>
            <!--
            <pre v-show="debug_show_optimizer_settings"><a href="#" @click.prevent="debug_show_optimizer_settings = false">hide</a>
            {{optimizer_settings_text}}</pre>
            <pre v-show="!debug_show_optimizer_settings"><a href="#" @click.prevent="debug_show_optimizer_settings = true">show</a></pre>
            -->

            <h4>Optimizer Results (Raw):</h4>
            <a href="#" @click.prevent="debug_show_optimizer_results_raw = !debug_show_optimizer_results_raw">{{debug_show_optimizer_results_raw ? 'hide' : 'show'}}</a>
            <pre v-show="debug_show_optimizer_results_raw">{{optimizer_result_data}}</pre>
            <pre v-show="!debug_show_optimizer_results_raw">{...}</pre>

            <h4>Optimizer Results:</h4>
            <a href="#" @click.prevent="debug_show_optimizer_results = !debug_show_optimizer_results">{{debug_show_optimizer_results ? 'hide' : 'show'}}</a>
            <!-- <pre v-show="debug_show_optimizer_results">{{mapped_optimizer_results}}</pre>
            <pre v-show="!debug_show_optimizer_results">[...]</pre> -->
          </el-card>

        </el-main>

      </el-container>

    </el-container>
  </el-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import DevGoalConfig from '@/components/OptimizerDevPage/DevGoalConfig';
import util from '@/util';
import moment from '@/moment-gp.js';
import { FullCalendar } from 'vue-full-calendar'
import TimezonePicker from '@/components/Elements/TimezonePicker'

import 'fullcalendar/dist/fullcalendar.css'

export default {
  data: () => ({
    debug_show_optimizer_settings: false,
    debug_show_optimizer_results: false,
    debug_show_optimizer_results_raw: false,
    debug_show_calendar: false,
    debug_show_table: false,
    debug_optimizer_response_time: 0,
    optimization_running: false,
    // mapped_optimizer_results: require('@/assets/action_plan_results.json'),
    optimizer_result_data: null,
    user_error: null,
    optimizer_algorithm: 'goalpilot_action_plan_v2',
    user_timezone: '', // HACK: not null
    planning_horizon: 14,
    optimizer_settings: null,
    optimizer_settings_text: '{ Results show up here }',
    new_project_title: "New Lane",
    selected_project_type: 'sunburst',
    calendar_config: {
      // see: https://fullcalendar.io/docs
      // height: 1400,
      firstDay: 1,
      editable: false,
      selectable: false,
      minTime: "06:00:00",
      maxTime: "22:00:00",
      businessHours: {
        // days of week. an array of zero-based day of week integers (0=Sunday)
        dow: [ 1, 2, 3, 4, 5 ], // Monday - Friday
        start: '8:00',
        end: '18:00',
      }
    }
  }),
  created() {
    this.user_timezone = this.$models.userSettings.getters.user_get_timezone;
  },
  computed: {
    user_get_timezone() {
      return this.$models.userSettings.getters.user_get_timezone;
    },
    ...mapGetters("user", [
      "userData",
    ]),
    ...mapGetters("goal", [
        "goal_list_ids",
        "goal_list_meta_ready_without_deleted",
        "goal_list_meta_ready_with_deleted",
        // "effort_list_all",
        "effort_by_effort_id"
    ]),
    effort_list_all() {
      return this.$models.commitment.getters.commitment_list_all;
    },
    ...mapGetters('timeslots', [ // << TODO
      'timeslot_collection_list',
      'timeslot_collection_by_timeslot_collection_id',
      'flattened_calendar_data_by_timeslot_collection_id',
      'weekday_preferences_by_timeslot_collection_id_sorted',
      'exceptions_by_timeslot_collection_id_sorted',
      'flattened_calendar_data_all',
    ]),
    ...mapGetters("optimizer", [
      'mapped_optimizer_results',
      'optimizer_input'
    ]),

    /*mapped_optimizer_results_filtered() {
      let timestampFrom = moment().unix()
      let timestampUntil =  timestampFrom + 86400 * 3
      return this.mapped_optimizer_results({ timestampFrom:timestampFrom, timestampUntil: timestampUntil })
    },*/

    // TODO: move to store
    optimizer_results_calendar() {

      let eventlist_calendar = this.mapped_optimizer_results.map((item) => {

        let timeslotCollectionId = this.effort_by_effort_id(item.commitmentId).timeslotCollectionId;
        let timeslotCollectionColor = this.timeslot_collection_by_timeslot_collection_id(timeslotCollectionId).color;
        return {
          title:    this.effort_by_effort_id(item.commitmentId).name,
          // start:    item.day + 'T' + (item.start.length === 4 ? '0' : '') + item.start + ':00',
          // end:      item.day + 'T' + (item.end.length === 4 ? '0' : '') + item.end + ':00',
          // start:    moment.unix( item.start ).tz(this.user_get_timezone),
          // end:      moment.unix( item.end ).tz(this.user_get_timezone),
          start:    item.start,
          end:      item.end,
          allDay:   false,
          color:    timeslotCollectionColor,
          // textColor: 'black',
        };
      });
      return eventlist_calendar;
    },

    project_invite_list() {
      let user = this.userData;
      if (user && 'projectInviteList' in user) {
        return Object.keys(user.projectInviteList).map(key => {
          return { ...user.projectInviteList[key], id: key };
        });
      } else {
        return [];
      }
    },
    timeslotCollectionsSelectOptions() {
      return this.timeslot_collection_list.map(item => {
        return { id: item.$id, label: item.name, color: item.color }
      });
    }
  },
  methods: {
    ...mapActions("project", [
      "create_project",
      "accept_invitation"
    ]),
    ...mapActions("optimizer", [
      'optimizer_run'
    ]),

    handleDragStart(event) {
      this.$refs.planner.handleDragStart(event)
    },

    onClickAddLane() {
      console.log("Creating project with title", this.new_project_title)
      console.log("selected_project_type", this.selected_project_type)
      this.create_project({
          title: this.new_project_title,
          type: this.selected_project_type
      });
    },

    onAcceptInvitation(invitation_id, invitation_name, accept) {
      this.accept_invitation({
        project_id: invitation_id,
        project_name: invitation_name,
        accept: accept
      })
    },

    runOptimize() {

      console.log("*** runOptimize ***");
      // console.log('entered runOptimize', this.timeslot_collection_list, this.effort_list_all)

      let user_timezone = this.user_get_timezone;
      let optimizer_payload = this.optimizer_input(this.planning_horizon);
      let optimizer_settings = {
        planning_horizon:     this.planning_horizon,
        user_timezone_iso:    user_timezone ? moment.tz(user_timezone).format().substr(-6) : 'Z',
        user_timezone_offset: moment.tz(user_timezone).utcOffset(),
        user_timezone_name:   user_timezone,
        optimizer:            this.optimizer_algorithm,
        optimizer_payload:    optimizer_payload,
      }

      this.optimizer_settings = optimizer_settings;
      this.optimizer_settings_text = JSON.stringify(optimizer_settings, undefined, 2);
      console.log("[Optimizer] Input Configuration:", JSON.parse(this.optimizer_settings_text));

      if ( this.dry_run ) {
        return
      }

      const USE_CORS_WORKAROUND = false;
      //const CLOUD_FUNCTION_URL = 'https://europe-west1-goalpilot-dev.cloudfunctions.net/milestone-optimizer-1024-http';
      //const CLOUD_FUNCTION_URL = 'https://europe-west1-goalpilot-dev.cloudfunctions.net/milestone-optimizer-1024-http';
      //const CLOUD_FUNCTION_URL = 'https://europe-west1-goalpilot-dev.cloudfunctions.net/milestone-optimizer-512-http';
      const CLOUD_FUNCTION_URL = 'https://europe-west1-goalpilot-dev.cloudfunctions.net/milestone-optimizer-256-http';
      //const CLOUD_FUNCTION_URL = 'https://europe-west1-goalpilot-dev.cloudfunctions.net/milestone-optimizer-128-http';

      this.optimization_running = true;

      if ( !USE_CORS_WORKAROUND ) {

        this.user_error = null;
        this.optimizer_result_data = null;

        this.optimizer_call_cloudfunction({ url: CLOUD_FUNCTION_URL, optimizer_settings: this.optimizer_settings })
          .then(({ json, response_time }) => {
            this.optimization_running = false;
            this.optimizer_result_data = json;
            this.debug_optimizer_response_time = response_time;
          })
          .catch((user_error) => {
            this.user_error = user_error;
            this.optimization_running = false;
          })
      } else {
        let id = this.project_id;
        let popup = window.open(
          CLOUD_FUNCTION_URL + "?project_id=" + id, "_blank",
          "toolbar=no,scrollbars=yes,resizable=yes,location=yes,menubar=no,status=no,titlebar=no,right=10,left=10,width=200,height=50");
        popup.blur();
        window.focus();
        setTimeout(() => {
          this.optimization_running = false;
        }, 3000)
      }
    },

    onExportJSON() {
      console.log('onExportJSON')
      let dryRunBefore = this.dry_run;
      this.dry_run = true;
      if ( this.optimizer_settings === null ) {
        this.runOptimize();
      }
      this.dry_run = dryRunBefore;
      console.log('onExportJSON', this.optimizer_settings)
      util.saveJSON(this.optimizer_settings,
        moment().format('YYYY-MM-DD_HH-MM') + "_opt-export.json" );
    }
  },
  components: {
    FullCalendar,
    // DevGoalConfig,
    TimezonePicker,
  }
};
</script>

<style>
.goal-list .el-button.add-goal {
  margin: 1em;
}
.goal-list .el-card {
  margin: 1em;
}
</style>
